import { getBudgetCurrentStatus } from "../types/budget/budget";
import { ClosingControlState, ClosingStatus } from "../types/closing-control.type";
import { BudgetListItem } from "./budget-adapters";

/**
 * Orçamentos que estão de fato na etapa de Fechamento — mesmo critério usado
 * por `validateClosingBudget` (project.context) para liberar a aprovação do
 * projeto: última versão do `versionHistory` com status `APPROVED`.
 */
export function selectClosingBudgetIds(
  budgetList: BudgetListItem[] = [],
): string[] {
  return budgetList
    .filter(
      (budget) =>
        budget?.status !== "DELETED" &&
        getBudgetCurrentStatus(budget?.versionHistory) === "APPROVED",
    )
    .map((budget) => budget?._id)
    .filter((id): id is string => !!id);
}

/**
 * Status de fechamento do PROJETO a partir dos estados por orçamento.
 *
 * O fechamento é por orçamento (`budget.closingStatus`), mas o status do
 * projeto é único: basta UM orçamento em Fechamento já enviado para Pré
 * Fechamento para o projeto poder ir para Pré-Fechamento.
 */
export function pickProjectClosingStatus(
  states: (ClosingControlState | undefined | null)[],
): ClosingStatus {
  if (states.some((state) => state?.closingStatus === "PRE_CLOSING")) {
    return "PRE_CLOSING";
  }

  const known = states.find((state) => !!state?.closingStatus);
  return known?.closingStatus ?? null;
}
